<template>
  <div>
    <svg width="300" height="200">
      <line
        v-for="(line, index) in triangularLines"
        :x1="line.x1"
        :y1="line.y1"
        :x2="line.x2"
        :y2="line.y2"
        stroke="black"
        :key="index"
      ></line>
    </svg>
    <svg width="300" height="200">
      <line
        v-for="(line, index) in squareLines"
        :x1="line.x1"
        :y1="line.y1"
        :x2="line.x2"
        :y2="line.y2"
        stroke="black"
        :key="index"
      ></line>
    </svg>
    <svg width="300" height="200">
      <pattern
        id="hex"
        :width="hexy.width"
        :height="hexy.height"
        patternUnits="userSpaceOnUse"
      >
        <line
          v-for="(line, index) in hexy.lines"
          :x1="line.x1"
          :y1="line.y1"
          :x2="line.x2"
          :y2="line.y2"
          stroke="black"
          :key="index"
        />
      </pattern>
      <rect
        x="0"
        y="0"
        width="300"
        height="200"
        style="stroke: #000000; fill: url(#hex);"
      />
    </svg>
    <input type="range" name="" id="" v-model="scale" min="10" max="100" />
    <button @click="toggle_show()">{{ displayOnOff }}</button>
  </div>
</template>

<script>
export default {
  name: "RegularPolygon",
  data() {
    return {
      scale: 18
    };
  },
  computed: {
    rx() {
      return 100 * Number(this.ratio);
    },
    cx() {
      return 300 + Math.sqrt(this.ratio * this.ratio - 1) * 100;
    },
    cx2() {
      return 300 - Math.sqrt(this.ratio * this.ratio - 1) * 100;
    },
    displayOnOff() {
      if (this.displayMidPoints) return "hide";
      else return "show";
    },
    triangularLines() {
      let triangularLines = [];
      for (var i = 0; i * this.scale * Math.sqrt(3) < 400; i++) {
        let x1 = 0;
        let x2 = 300;
        let y = (this.scale * i * Math.sqrt(3)) / 2;
        triangularLines.push({ x1: x1, y1: y, x2: x2, y2: y });
      }
      for (i = 0; i * this.scale < 300 + 200 / Math.sqrt(3); i++) {
        let x1 = i * this.scale;
        let x2 = i * this.scale - 200 / Math.sqrt(3);
        let x1_ = i * this.scale;
        let x2_ = i * this.scale + 200 / Math.sqrt(3);
        let y1 = 0;
        let y2 = 200;
        triangularLines.push({ x1: x1, y1: y1, x2: x2, y2: y2 });
        triangularLines.push({ x1: x1_, y1: y1, x2: x2_, y2: y2 });
      }
      return triangularLines;
    },
    squareLines() {
      let squareLines = [];
      for (var i = 0; i * this.scale < 200; i++) {
        let x1 = 0;
        let x2 = 300;
        let y = this.scale * i;
        squareLines.push({ x1: x1, y1: y, x2: x2, y2: y });
      }
      for (i = 0; i * this.scale < 300; i++) {
        let y1 = 0;
        let y2 = 200;
        let x = this.scale * i;
        squareLines.push({ x1: x, y1: y1, x2: x, y2: y2 });
      }
      return squareLines;
    },
    hexy() {
      let width = 3 * this.scale;
      let height = this.scale * Math.sqrt(3);
      let lines = [];
      /*
      __
        \__/
      __/  \
      */
      /* eslint-disable */
      lines.push({ x1: 0, y1: 0, x2: this.scale, y2: 0 });
      lines.push({ x1: 0, y1: this.scale * height, x2: this.scale, y2: this.scale * height });
      lines.push({ x1: this.scale, y1: 0, x2: this.scale * 1.5, y2: this.scale * Math.sqrt(3) * 0.5 });
      lines.push({ x1: this.scale, y1: height, x2: this.scale * 1.5, y2: this.scale * Math.sqrt(3) * 0.5 });
      lines.push({ x1: this.scale * 2.5, y1: this.scale * Math.sqrt(3) * 0.5, x2: this.scale * 1.5, y2: this.scale * Math.sqrt(3) * 0.5 });
      lines.push({ x1: this.scale * 2.5, y1: this.scale * Math.sqrt(3) * 0.5, x2: width, y2: 0 });
      lines.push({ x1: this.scale * 2.5, y1: this.scale * Math.sqrt(3) * 0.5, x2: width, y2: height });
      return { width: width, height: height, lines: lines };
    } /* eslint-enable */
  },
  methods: {
    toggle_show: function() {
      this.displayMidPoints = !this.displayMidPoints;
    }
  }
};
</script>

<style lang="css">
.ellipse {
  float: left;
}
</style>
